import { useLoader,useFrame,applyProps, useThree ,useGraph } from "@react-three/fiber";
import React, { useRef ,useLayoutEffect,useState, useEffect,useMemo} from "react";
import { Html} from '@react-three/drei'
import { useGLTF } from '@react-three/drei'
import * as  SkeletonUtils  from "three/examples/jsm/utils/SkeletonUtils"

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import * as THREE from "three";
import {useCanvas} from 'store/AppStore'


// Let's make the marker into a component so that we can abstract some shared logic
function Marker({ children,visible,occludee, ...props }) {
    const [occluded, setOccluded] = useState(false);
    
    useEffect(() => {
        if (visible){
        const timer = setTimeout(() => {
          setOccluded(true);
        }, 100); // adjust the delay as needed
        return () => clearTimeout(timer);
       }else{
        setOccluded(false);
      }}, [visible]);

    return (
        <>
        {visible && (
      <Html
        // We just interpolate the visible state into css opacity and transforms
        style={{ transition: 'all 0.2s',  userSelect: 'none', opacity: occluded  ? 1 : 0, transform: `scale(${occluded  ? 1 : .25})` }}
        {...props}>
        {children}
      </Html>)}
      </>
    )
  }
  
  /*
  
// Let's make the marker into a component so that we can abstract some shared logic
function Marker({ children,visible,occludee, ...props }) {
    const [occluded, occlude] = useState(false);

    return (
        <>
        {visible && occludee && (
      <Html
        // 3D-transform contents
        // transform
        // Hide contents "behind" other meshes
        occlude={occludee}
        // Tells us when contents are occluded (or not)
        onOcclude={occlude}
        // We just interpolate the visible state into css opacity and transforms
        style={{ transition: 'all 0.2s',  userSelect: 'none', opacity: occluded || !visible ? 0 : 1, transform: `scale(${occluded || !visible ? 0.25 : 1})` }}
        {...props}>
        {children}
      </Html>)}
      </>
    )
  }
  */

  //style={{ opacity, transform }}

  export function useSkinnedMeshClone(path) {
    const {scene, materials, animations} = useGLTF(path);
    const clonedScene = useMemo(() => SkeletonUtils.clone(scene), [scene]);
    const {nodes} = useGraph(clonedScene);
  
    return {scene: clonedScene, materials, animations, nodes};
  }



const Model = props => {
    const { seqId,setSequenceName,setSequenceTime } = useCanvas();
    const { isStickText, setStickText } = useCanvas()
    //const  [isStickText, setStickText ] = useState(false)
    const ref = useRef()
    const [initMarker,setInitMarker] = useState(0)
    const [isPlaying,setIsPlaying] = useState(false)
    const did = useRef(false) // pour eviter de player au chargement du gltf
    const occludeeRefs = useRef([]);

    const model = useLoader(
        GLTFLoader,
        props.path,
        
    )
  

 
    //const {scene, materials, animations, nodes} = useSkinnedMeshClone(props.path); // with 'clonable' option

    //console.log(model);
    const mixer = useMemo(() => new THREE.AnimationMixer(model.scene), [model.scene])

    //const { camera } = useThree() 
    
    // Marker de blender avec les pause des différentes section 
    // normal->eclater->fermer eclater->ranger holder->sortir holder
    const pauseMarker = [2.84,5.76,11,14.52,21.2,27.24]
    const timeEachAnim = [2.84,2.8,5.24,3.52,6.7,5.95]
    // the time between we show the label of the stick
    const showStickLabelTime = [9.9,12]
    const seqenceName = ["","1. Open IQOS","2. Close IQOS", "3. Open Stick","4. Closing Stick","5. Charging IQOS", "6. Using IQOS"]
    //let initMarker = 0
    
    let action = null


    console.log("REINIT")
/*
  if ( model.animations.length > 0){
        mixer = new THREE.AnimationMixer(model.scene)
        
        model.animations.forEach(clip => {
            action = mixer.clipAction(clip)
            //console.log(action)
            action.stop()
        })
        
    }
*/
    // quand on recois une nouvelle sequence a player on lance l'animation
    useEffect(()=>{
        // did.current permet de ne pas lancer la premiere fois au chargement de la page
        if (did.current) {
            window.utalk.playcanva = 1
            //console.log("USEEFFECT ..play ...",seqId)
          } else {
            did.current = true;
            //console.log("NOT_PLAY BECAUSE FIRST TIME")
          }
       
    },[seqId])

    // on arrive sur la page 3D on init les animation
    useEffect(()=>{

        if (props.reset === true){
            //console.log("RESET ANIMATION...", props.reset)
            model.animations.forEach(clip => {
                action = mixer.clipAction(clip)
                action.time = 0 
                action.play()
                action.paused = true
                setInitMarker(0)
                setSequenceTime(timeEachAnim[0])
                setSequenceName(seqenceName[1])
            })
            //camera.position.set(-6, 8, 18)
        }
        
    },[props.reset])

/*
    useEffect(() => {
        // Get the object you want to attach the HTML element to
        //--const targetObject = model.scene.getObjectByName('Chargeur');
        const targetObject = scene.getObjectByName('Chargeur');
    
    
    
        // Attach the HTML element to the object's position in the scene
        //targetObject.add();
    
        // Save the reference to the object so it can be used in the render method
        objectRef.current = targetObject;
      }, [scene]);
*/

    // la liste des different objet qui peuvent faire de l'ombre
    const words = ['080_0200_METAL_HOUSING', 'Mesh018', 'Mesh018_1', '101_0024_Cosmetic_Cover_11A', '101_0025_Plunger_5A(Default)', '101_0032_Cover_Screw_3A'];
    
    // ajustement de certain materiaux directement dans threeJS
    const roughness = [{
        material: 'Grey_Dark',
        roughness:1.5,
        metalness:.2,
        color:new THREE.Color( .6, .62, .65 ),
    },{
        material: 'LED_POWER',
        roughness:.3,
        color:new THREE.Color( 1, 1, 1),
    }
    ,{
        material: 'Grey_Light',
        roughness:1.5,
        color:new THREE.Color( 1, 1, 1),
    }
    ,{
        material: 'Circuit',
        roughness:1.5,
       
    },{
        material: 'Black_Plastic',
        roughness:2,
       
    },{
        material: 'White_Plastic',
        roughness:2,
       
    }]

        

      useEffect(() => {
        // list des object qui permet l'occlusion des etiquette
          const occludee = ['1_front_set004',  '2_tabaco001','3_AirFlow001','4_CollingPlug001','0_Filtre001','Papier_Ext004','papier_int_1001','papier_int_1002','papier_int_1006','Papier_Ext001']

  
      const refs  = occludee.map((name) => {
        const object = model.scene.getObjectByName(name);
        if (object && object.layers) { 
          return object;
        } else {
          console.warn(`Object ${name} not found in the model.`);
          return null;
        }
      }).filter((object) => object !== null);
      // Update the refs in the state
         occludeeRefs.current = refs;

    }, [model]);




      useLayoutEffect(() => {
        //console.log('update')
        model.scene.traverse((o) => {
    
          if (o.isMesh) {
            //console.log(o.name)
         
            const result = words.filter(word => word == o.name);
           

            //console.log(result)
            if (result.length >1000 || false){
                applyProps(o, { castShadow: true, receiveShadow: true, 'material-envMapIntensity': 1 })
                //console.log("traverse...")
                
            }
            if (o.material){
            
            //console.log("check",o.material.name)
            const resMaterial = roughness.filter((mat) => {
                return mat.material === o.material.name
            })
            if (resMaterial.length >0){
                if (resMaterial[0].roughness){
                    
                    o.material.roughness = resMaterial[0].roughness
                }
                if (resMaterial[0].color){
                    o.material.color = resMaterial[0].color
                }
                if (resMaterial[0].metallic){
                    o.material.metalness = resMaterial[0].metalness
                }
            }
            
            }
            //console.log(o)
          }

          
        })
      }, [])


    // permet de player les animation 
    useFrame((scene,delta) =>{
        if (window.utalk.playcanva >0){
            //console.log("PLAY_NEX...T")
            window.utalk.playcanva = 0
            setIsPlaying(true)
            //setSeqId(initMarker)
            
            window.utalk.playSequenceId = initMarker
            //--model.animations.forEach(clip => {
            model.animations.forEach(clip => {
                action = mixer.clipAction(clip)
                action.setLoop(THREE.LoopOnce,0)
                //console.log(action)
                //console.log(ref)
                action.play()
                action.paused = false
            })
        }

        // si on est en train de player on va jusqu'au prochain stop
        if ( isPlaying){
            let posMarker = initMarker
            const currentTime = mixer?.clipAction(model.animations[0]).time

            // check if we show the label 
            if (currentTime >= showStickLabelTime[0] && currentTime <= showStickLabelTime[1]){ 
                
                setStickText(true);
            }else{
                
                setStickText(false);
            }
            
            const timeToStop = pauseMarker[posMarker]
           
            if (currentTime >= timeToStop){
                
                posMarker = posMarker + 1
                if (posMarker >= pauseMarker.length){
                    posMarker =  0
                }
                model.animations.forEach(clip => {
                    action = mixer.clipAction(clip)
                    if (posMarker == 0){
                        //console.log("RESTART... positon 0")
                        action.time = 0
                    }
                   
                    action.paused = true
                })
                setInitMarker(posMarker)
                setSequenceName(seqenceName[posMarker+1])
                setSequenceTime(timeEachAnim[posMarker])
                setIsPlaying(false)
            }
            //console.log(mixer?.clipAction(model.animations[0]).time)
        }
        mixer?.update(delta)
    })
    return (
        <>
        <primitive object={model.scene}  ref={props.groupRef} />
        <group position={[-7.49, 7.9, 1.57]} rotation={[0,0,0]}>
  <Marker visible={isStickText} occludee={occludeeRefs} rotation={[0, 0, 0]}>
   <div className="markerLabel" >1</div> 
  </Marker>
</group>
<group position={[-5.04, 7.65, .97]} rotation={[0,0,0]}>
  <Marker visible={isStickText} occludee={occludeeRefs} rotation={[0, 0, 0]}>
   <div className="markerLabel" >2</div> 
  </Marker>
</group>
<group position={[-5.75, 7.28, 1.57]} rotation={[0,0,0]}>
  <Marker visible={isStickText} occludee={occludeeRefs} rotation={[0, 0, 0]}>
   <div className="markerLabel" >4</div> 
  </Marker>
</group>
<group position={[-2.58, 7.25, 0.45]} rotation={[0,0,0]}>
  <Marker visible={isStickText} occludee={occludeeRefs} rotation={[0, 0, 0]}>
   <div className="markerLabel" >3</div> 
  </Marker>
</group>
<group position={[-.12, 7.05, 0.05]} rotation={[0,0,0]}>
  <Marker visible={isStickText} occludee={occludeeRefs} rotation={[0, 0, 0]}>
   <div className="markerLabel" >6</div> 
  </Marker>
</group>
<group position={[-5.1, 5.9, 2]} rotation={[0,0,0]}>
  <Marker visible={isStickText} occludee={occludeeRefs} rotation={[0, 0, 0]}>
   <div className="markerLabel">5</div> 
  </Marker>
</group>
<group position={[3.26, 5.7, .89]} rotation={[0,0,0]}>
  <Marker visible={isStickText} occludee={occludeeRefs} rotation={[0, 0, 0]}>
   <div className="markerLabel">7</div> 
  </Marker>
</group>
        </>
    )
}



/*

*/
//isLabelVisible

// blender 3.8 ,.8 , 6.8  --> position={[3.8, 6.8, -.8]
//useGLTF.preload(props.path)

export default React.memo(Model);